import * as React from 'react'
import MaskedInput from 'react-text-mask'

interface IMaskInputProps {
  inputRef: any
  mask: Array<string | RegExp>
}

const MaskInput: React.SFC<IMaskInputProps> = props => {
  const { inputRef, mask, ...other } = props

  return (
    <MaskedInput
      {...other}
      ref={inputRef}
      mask={mask}
      placeholderChar={'\u2000'}
    />
  )
}

export default MaskInput



// WEBPACK FOOTER //
// ./src/components/shared/MaskInput.tsx